import { render, staticRenderFns } from "./Seminars.vue?vue&type=template&id=28f4ccee"
import script from "./Seminars.js?vue&type=script&lang=js&external"
export * from "./Seminars.js?vue&type=script&lang=js&external"
import style0 from "./Seminars.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports